<rask-toggle-panel #togglePanel
    [defaultExpanded]="true"
    [noPadding]="true"
    [enableBackdrop]="true">
    <ng-container customHeader #customHeader>
        <rask-header size="3">
            <span>
                <span class="toggel-panel-label">Åtgärder</span>
                <span class="validationIcon">
                    @if (getIcon(); as validationIcon) {
                        <i class="fal {{validationIcon}}"></i>
                    }
                </span>
                <span class="panelIcon" (click)="$event.stopPropagation()">
                    @if (nvbSummary$ | async; as nvb) {
                        @if (nvb.total > 0) {
                            <rask-icon-stacked
                                icon="far fa-leaf"
                                [ngClass]="{ 'incomplete': nvb.missing > 0 }"
                                (click)="handleNvbIconClick()"
                                [text]="getNvbTooltip(nvb)">
                            </rask-icon-stacked>
                        }
                    }
                </span>
            </span>
            <div class="content" (click)="$event.stopPropagation()">
                <rask-action-button
                    aid="buttonCreateAtgard"
                    [options]="atgardsTyper$ | async"
                    [disabled]="(isReadonly$ | async) || !!!(atgardsTyper$ | async)"
                    alignment="right"
                    icon="far fa-plus"
                    [showChevron]="false"
                    (optionSelected)="addAtgard($event)">Lägg till ny åtgärd</rask-action-button>

                <rask-inline-toast
                    class="right"
                    [showToast]="atgardAdded$"
                    [viewInMillisseconds]="1000">
                    Åtgärd har lagts till på kontraktet
                </rask-inline-toast>
            </div>
        </rask-header>
    </ng-container>
    <div>
        @for (entity of (atgarder$ | async); track trackByFn(i, entity); let i = $index) {
        <div>
            <rask-atgard-item [entity]="entity"
                [index]="i">
            </rask-atgard-item>
        </div>
        }
    </div>

    <rask-vardeberakning
        *raskPermitted="[{role: 'RASK.Kopplanera', canView: false, canEdit: false}]; merge: true">
    </rask-vardeberakning>
</rask-toggle-panel>